import { render, staticRenderFns } from "./CandidateListProperties.vue?vue&type=template&id=c7040e54&"
import script from "./CandidateListProperties.vue?vue&type=script&lang=js&"
export * from "./CandidateListProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports